import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashedLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5842_3512)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2 8H4",
				stroke: "#363636"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.66602 8H10.666",
				stroke: "#363636"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.33398 8L7.33398 8",
				stroke: "#363636"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 8L14 8",
				stroke: "#363636"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5842_3512",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
			fill: "white"
		})
	}) })]
});
export default SvgDashedLine;
